// Get meta data for sending forms via AJAX
export const getMetaValue = (name) => {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  return element.getAttribute('content');
};

export default getMetaValue;
